import { Injectable } from '@angular/core';
import { PopupWindowService } from '@app/services';
import { ToolbarItems, ToolbarActions } from '@app/shared/grid/toolbar/toolbar/toolbar.component';
import { Observable, Subject } from 'rxjs';

export const SkipWorkingDocumentRequestParameter = 'skip-working-document';
export const IgnoreCTMSUIRequestParameter = 'ignore-ctms-ui';

export type DocumentViewerRequestParamOptionType =
  | {
      name: 'skipWorkingDocument';
      requestParam: typeof SkipWorkingDocumentRequestParameter;
      value: string;
    }
  | {
      name: 'ignoreCTMSUI';
      requestParam: typeof IgnoreCTMSUIRequestParameter;
      value: string;
    };

@Injectable({
  providedIn: 'root',
})
export class DocumentViewerService {
  private actions: ToolbarItems<any, any>;
  private actionsSub = new Subject<ToolbarItems<any, any>>();

  constructor(private popupWindowService: PopupWindowService) {}

  getViewerUrl(roomId: number, documentId: number): string {
    return window.location.href.replace(window.location.hash, `#document-viewer/${roomId}/${documentId}`);
  }

  openDocumentInWindow(
    roomId: number,
    documentId: number,
    uniqWindow?: boolean,
    url?: string,
    additionalRequestParams?: DocumentViewerRequestParamOptionType[],
    features?: string,
    inNewTab?: boolean,
  ) {
    url = url || window.location.href.replace(window.location.hash, `#document-viewer/${roomId}/${documentId}`);
    this.popupWindowService.openWindow({
      url,
      name: this.getViewerName(roomId),
      entityId: `${documentId}`,
      uniqWindow,
      additionalRequestParams,
      features,
      inNewTab,
    });
  }

  /** Opens the document viewer route in a new browser tab (not a sized popup). */
  openDocumentInBrowserTab(roomId: number, documentId: number) {
    this.openDocumentInWindow(roomId, documentId, true, undefined, undefined, undefined, true);
  }

  closeWindow(roomId: number, documentId: number) {
    this.popupWindowService.closeWindow(this.getViewerName(roomId), `${documentId}`);
  }

  private getViewerName(roomId: number): string {
    return `TiDocumentViewer_${roomId}`;
  }

  setActions(actions?: ToolbarItems<any, any>) {
    // set undefined to mark no coding yet, or null to mark there is no actions
    this.actions = actions;
    this.actionsSub.next(this.actions);
  }

  getActions(): ToolbarActions<any, any> {
    return new Observable((obs) => {
      if (this.actions !== undefined) {
        obs.next(this.actions);
      }
      this.actionsSub.asObservable().subscribe((res) => obs.next(res));
    });
  }
}
